export function assertPositive(value: unknown | undefined, errorMessage: string = 'Found a negative value', muteError = false){
    if (!value){
        if (muteError){
            console.assert(!!value, errorMessage);
        }else{
            throw new Error(errorMessage);
        }
    }
    return value;
}

export function assertNonNullable<T>(value: T | undefined, errorMessage: string = 'Found an unexpected nullable value', muteError = false){
    if (!value){
        if (muteError){
            console.assert(!!value, errorMessage);
        }else{
            throw new Error(errorMessage);
        }
    }
    return value as T;
}


export function unreachable(errorMessage: string = 'Found a unreachable statement'){
    return assertPositive(
        false,
        errorMessage
    );
}
